import { useNavigate } from 'react-router-dom'
import moment from 'moment'

import { selectPayrollByUuid } from '../../payroll.selectors'
import { PaymentOverview } from './PayrollOverview'
import { PayrollDetails } from './PayrollDetails'
import { PayrollHeader } from './PayrollHeader'
import { formatCurrency } from '@/utils/currencyHelpers'
import { Button, Icon, Separator, Text } from '@/ui'
import { DATE_FORMATS } from '@/utils/dateHelpers'
import { useReselector } from '@/utils/sharedHooks'
import { Gusto_BankAccount } from '../../generated_gusto_types'
import { TypographyStyles } from '@/styles'
import { faCheckCircle, faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
export const PayrollConfirmationTab = ({
  uuid,
  bankAccount,
}: {
  uuid: string
  bankAccount?: Gusto_BankAccount
}) => {
  const navigate = useNavigate()
  const payroll = useReselector(selectPayrollByUuid, uuid)

  if (!payroll) {
    return null
  }

  const {
    pay_period: { start_date, end_date },
    totals,
    payroll_deadline,
  } = payroll

  const companyDebit = totals?.company_debit || '0.00'

  return (
    <div className="flex flex-col gap-6">
      <PayrollHeader upcomingPayroll={payroll} currentTab={3} />

      <div className="flex flex-row text-left w-full md:w-1/2">
        <Icon
          icon={faCheckCircle}
          color="green"
          className="inline-block mr-2"
          size="1x"
        />
        <Text variant={TypographyStyles.DISPLAY_SM}>You&apos;re all set!</Text>
      </div>

      <Text variant={TypographyStyles.BODY_MD}>
        Time to take a back seat. We will withdraw{' '}
        <span className="text-green-600">{formatCurrency(companyDebit)}</span>{' '}
        from your Bank Account (
        <span className="text-green-600">
          {bankAccount?.account_type}, {bankAccount?.hidden_account_number}
        </span>
        ) on{' '}
        <span className="text-green-600">
          {moment(payroll_deadline).format(DATE_FORMATS.DAY_OF_WEEK_DAY_MONTH)}
        </span>
        . Please ensure these funds are available in your attached business bank
        account.
      </Text>

      <Text variant={TypographyStyles.BODY_MD}>
        Payroll Run for {moment(start_date).format(DATE_FORMATS.DISPLAY_SHORT)}{' '}
        - {moment(end_date).format(DATE_FORMATS.DISPLAY_SHORT)}
      </Text>
      <Separator />
      <PaymentOverview payroll={payroll} />
      <Separator />
      <PayrollDetails uuid={uuid} />

      <div className="flex justify-end">
        <div className="w-full md:w-1/3">
          <Button
            onClick={() => navigate('/payroll/run_payroll')}
            className="w-full"
          >
            <Icon icon={faArrowLeft} className="mr-2" />
            Back to dashboard
          </Button>
        </div>
      </div>
    </div>
  )
}
